import actionTypes from '../costants';

export const setCategories = (meals) => ({
  type: actionTypes.SET_CATEGORIES,
  payload: meals,
});

export const changeFilter = (filter) => ({
  type: actionTypes.CHANGE_FILTER,
  payload: filter,
});

export const selectItem = (meal) => ({
  type: actionTypes.SELECT_ITEM,
  payload: meal,
});
